import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Signals when the backend login-history record (IsLoggedin=true) has been
 * committed for the current session. TenantGuard waits for this before calling
 * client/tenants, eliminating the race condition where the middleware session
 * check fires before the login-status update has reached the DB.
 */
@Injectable({ providedIn: 'root' })
export class AuthReadyService {
  private ready$ = new BehaviorSubject<boolean>(false);

  get isReady$(): Observable<boolean> {
    return this.ready$.asObservable();
  }

  markReady(): void {
    this.ready$.next(true);
  }

  reset(): void {
    this.ready$.next(false);
  }
}
